export default __webpack_public_path__ + "static/media/i1800.e3d3d77b.jpg";